import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { url_servicios } from 'src/app/config/config';
import { DoctorV2 } from 'src/app/core/models';

type ListResponse = {
  users: { data: DoctorV2[] };
};

type DoctorUserResponse = {
  user: DoctorV2;
};

type DoctorStatusResponse = {
  message: number | string;
  message_text?: string;
};
@Injectable({
  providedIn: 'root',
})
export class DoctorService {
  roles: unknown[] = [];
  permissions: unknown[] = [];

  private http = inject(HttpClient);

  list() {
    const URL = url_servicios + '/doctors';
    return this.http.get<ListResponse>(URL);
  }

  listConfig() {
    const URL = url_servicios + '/doctors/config';
    return this.http.get<unknown>(URL);
  }
  listConfigLocation(location_id: number) {
    const URL = url_servicios + '/doctors/configlocation/' + location_id;
    return this.http.get<unknown>(URL);
  }
  storeDoctor(data: unknown) {
    const URL = url_servicios + '/v2/users/createUser';
    return this.http.post<unknown>(URL, data);
  }
  showDoctor(doctor_id: number | string) {
    const URL = url_servicios + '/doctors/show/' + doctor_id;
    return this.http.get<DoctorUserResponse>(URL);
  }

  editDoctor(data: unknown, doctor_id: number | string) {
    const URL = url_servicios + '/v2/users/editUser/' + doctor_id;
    return this.http.post<unknown>(URL, data);
  }

  showDoctorProfile(doctor_id: number | string) {
    const URL = url_servicios + '/doctors/profile/' + doctor_id;
    return this.http.get<DoctorUserResponse>(URL);
  }
  editDoctorProfile(data: unknown, doctor_id: number | string) {
    const URL = url_servicios + '/doctors/update/' + doctor_id;
    return this.http.post<unknown>(URL, data);
  }

  yo(user: unknown) {
    // const headers = this.headers;
    const URL = url_servicios + '/me';
    return this.http.post<unknown>(URL, user);
  }

  deleteDoctor(doctor_id: number | string) {
    const URL = url_servicios + '/doctors/destroy/' + doctor_id;
    return this.http.delete<DoctorStatusResponse>(URL);
  }

  updateStatus(data: unknown, doctor_id: number | string) {
    const URL = url_servicios + '/doctors/update/status/' + doctor_id;
    return this.http.put<DoctorStatusResponse>(URL, data);
  }

  getEmployeesByLocation(location_id: number | string) {
    const URL = url_servicios + '/doctors/employeesbylocation/' + location_id;
    return this.http.get<unknown>(URL);
  }

  changePassword(userId: number, newPassword: string, newPasswordConfirmation: string) {
    const URL = `${url_servicios}/v2/users/${userId}/change-password`;
    return this.http.patch<{status: string, message: string}>(URL, {
      new_password: newPassword,
      new_password_confirmation: newPasswordConfirmation
    });
  }
}
